const SuccessPage = () => <div style={{ fontSize: '48px' }}>👍</div>
export default SuccessPage
